<template>
    <div>
        <div  v-if="item">
             <div class="answerlist" @click="golist(item)">
                <div class="answerlist-tit">
                    {{item.title}}
                </div>
                <div class="answerlist-my" v-if="item.nick"> 
                    
                    <img :src="$baseurl+item.headImg" @click.stop="gotomy(item)">
                    <span class="answerlist-my-stit">{{item.nick}}</span>
                </div>
                <div class="answerlist-content van-multi-ellipsis--l3">
                    {{item.content}}
                </div>
                <!-- <div class="answerlist-footer">
                    <span>59<span class="answerlist-footer-wz1">赞</span></span>
                    <span class="answerlist-footer-wz2">·</span>
                    <span>2<span class="answerlist-footer-wz3">评论</span></span>
                </div> -->
            </div>
        </div>
       
    </div>
</template>
<script>
export default {
    name:'comanswer',
    props:{
        item:{
            type:Object,
            default:undefined
        }
    },
    data(){
        return{

        }
    },
    created(){

    },  
    methods:{
        gotomy(item){
            this.$router.push({path:'/communitymy',query:{id:item.memberPersonalId}});
        },
        golist(item)
        {
            var itemjson=JSON.stringify(item);
            this.$router.push({path:'/answerlist',query:{item:itemjson,id:item.id}});
        }
    }
}
</script>
<style lang="scss" scoped>
.answerlist{
    padding: 8px 18px;
    background-color: #fff;
    margin-top:10px;
    font-size: 13px;
    text-align: left;
    line-height: 22px;

    .answerlist-tit{
        font-size: 15px;
        font-weight: bold;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .answerlist-my{
        line-height: 20px;
        margin-bottom: 5px;
        color:#595959;
        font-size: 12px;
        img{
            width: 18px;
            height: 18px;
            border-radius: 50%;
        }
        .answerlist-my-stit{
            margin-left: 5px;
        }
    }
    .answerlist-content{
        word-break: break-all;

    }

    .answerlist-footer{
        color:#979797;
        font-size: 12px;
        .answerlist-footer-wz1{
            padding-left: 3px;
            padding-right: 2px;
        }
        .answerlist-footer-wz2{
            padding-right: 2px;
        }
        .answerlist-footer-wz3{
            padding-left: 3px;
        }
    }
    
}
</style>